(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[698],{

/***/ 4931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(7763);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2745:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/carousel-arrow-left.0c4f3d2f.svg","height":42,"width":42});

/***/ }),

/***/ 7935:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/carousel-arrow-right.4a5dbdbe.svg","height":42,"width":42});

/***/ }),

/***/ 6162:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/about-casper.f9ebdda2.webp","height":704,"width":704,"blurDataURL":"data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAABQAgCdASoIAAgAAkA4JagCdLoB+AADJD7y48AA/nqfJqRh+bdCIxOY6AZO//wq3DEM1X/3kp3uyFxuvdqo/vAAAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/default-splash-card.0ded0b20.png","height":1667,"width":1667,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAqElEQVR42iWOOQrCABBF5wiC4lKIW+GWmEWSVo8QUAhoE21SBtLmDIE0aXOAtDmC1mlyn4cZhAczzPzP/4JhYjs4Lu5Zl5OFeeoRHZMZgyEizBcslmx3/Vs4GjyevN4kCbc7QcDlym4veD5VRdPQddQ1aUoUsVqLGsNQhWVJ2/L5kueIiKatN4iQZRSFXuOY0Vi0lWVrq/0BEWU8xXa01R+1en6PigzzB2D/YcmSCI2wAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 8838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardHorizontal4; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(8182);
;// CONCATENATED MODULE: ./src/assets/icons/arrow-card-icon.svg
/* harmony default export */ var arrow_card_icon = ({"src":"/_next/static/media/arrow-card-icon.a14f7300.svg","height":21,"width":13});
// EXTERNAL MODULE: ./src/@shared/components/icon/index.tsx + 3 modules
var icon = __webpack_require__(8068);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./src/@shared/components/cards/CardHorizontal4/CardHorizontal4.module.scss
var CardHorizontal4_module = __webpack_require__(8546);
var CardHorizontal4_module_default = /*#__PURE__*/__webpack_require__.n(CardHorizontal4_module);
;// CONCATENATED MODULE: ./src/@shared/components/cards/CardHorizontal4/CardHorizontal4.tsx






function CardHorizontal4(param) {
    let { sectionTitle , sectionDesc , customClass , hasArrow , items  } = param;
    const componentClass = "CardHorizontal4 ".concat((CardHorizontal4_module_default()).CardHorizontal4, " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb-5",
                    dangerouslySetInnerHTML: {
                        __html: sectionTitle !== null && sectionTitle !== void 0 ? sectionTitle : ""
                    }
                }),
                sectionDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-5",
                    children: sectionDesc
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: items === null || items === void 0 ? void 0 : items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "mb-4 position-relative",
                            md: 6,
                            lg: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    style: {
                                        backgroundColor: "".concat(item.bgColor)
                                    },
                                    className: (CardHorizontal4_module_default()).card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        className: (CardHorizontal4_module_default()).cardBody,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "title",
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "desc",
                                                children: [
                                                    " ",
                                                    item.desc
                                                ]
                                            }),
                                            hasArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "open-arrow position-absolute",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    source: arrow_card_icon.src
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, index)
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 3065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(699);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);





const baseUrl = "https://www.casperlabs.io/";
const siteName = "Casper Labs";
function CustomHead(param) {
    let { title , description ="" , og , twitter , business , children  } = param;
    if (!og) {
        og = {
            ogTitle: title,
            ogDescription: description,
            ogImage: _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src
        };
    }
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const key = (0,react__WEBPACK_IMPORTED_MODULE_4__.useId)();
    const ogUrl = "".concat(baseUrl.substring(0, baseUrl.length - 1)).concat(router.asPath);
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "192x192",
                href: "/android-chrome-192x192.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "512x512",
                href: "/android-chrome-512x512.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "".concat(baseUrl, "icons/navbar-toggle-icon.webp"),
                as: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: "Casper Labs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "googlebot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "bingbot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "5dpoinx6gwzawxktv7aakmzim1f23c"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: og.ogTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: og.ogDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: og.ogImage
            }),
            twitter && Object.keys(twitter).map((p)=>{
                const content = twitter[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:".concat(p),
                    content: content
                }, key + p);
            }),
            business && Object.keys(business).map((p)=>{
                const content = business[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "business:contact_data:".concat(p),
                    content: content
                }, key + p);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children
        ]
    }));
}


/***/ }),

/***/ 4516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Hero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5005);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5380);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Hero_module_scss__WEBPACK_IMPORTED_MODULE_2__);






function Hero(param) {
    let { halfTitle , title , desc , bgImage , linkButton , linkButton2 , customClass , col1 , col2 , colLg1 , colLg2 , children , childrenCol , isHeader  } = param;
    const componentClass = "Hero position-relative ".concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const childrenContentClass = "childrenContent ".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_2___default().childrenContent));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: "align-items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "content",
                    md: col1,
                    lg: colLg1,
                    children: [
                        halfTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "half-title",
                            children: halfTitle
                        }),
                        isHeader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "header-section-title mb-4",
                            dangerouslySetInnerHTML: {
                                __html: title !== null && title !== void 0 ? title : ""
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "header-section-title section-title-h2 mb-4",
                            dangerouslySetInnerHTML: {
                                __html: title !== null && title !== void 0 ? title : ""
                            }
                        }),
                        desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-4",
                            children: desc
                        }),
                        childrenCol && childrenCol === 1 && children,
                        linkButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: linkButton.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: linkButton2 && "me-4 mb-4 mb-lg-0",
                                variant: linkButton.variant,
                                children: linkButton.label
                            })
                        }),
                        linkButton2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: linkButton2.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                variant: linkButton2.variant,
                                children: linkButton2.label
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    style: {
                        backgroundImage: bgImage ? 'url("'.concat(bgImage, '")') : "none"
                    },
                    className: childrenContentClass,
                    md: col2,
                    lg: colLg2,
                    children: (!childrenCol || childrenCol === 2) && children
                })
            ]
        })
    });
}


/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6968);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5973);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__);




function ListLoader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "mt-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                md: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "text-green",
                    animation: "border",
                    role: "status",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FramerMotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3838);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function FramerMotion(param) {
    let { children , animation ="fadeUp" , y  } = param;
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setIsMobile(window.innerWidth <= 768);
        const handleResize = ()=>{
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    if (isMobile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: children
    });
    const fadeInProps = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    };
    const fadeUpProps = {
        initial: {
            opacity: 0,
            y: y && y || 250
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        transition: {
            type: "spring",
            stiffness: 50,
            duration: 2
        },
        viewport: {
            once: true
        },
        className: "framerMotion"
    };
    const animationProps = animation === "fadeIn" ? fadeInProps : fadeUpProps;
    const { ...motionProps } = animationProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        ...motionProps,
        children: children
    });
}


/***/ }),

/***/ 7602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHotspotForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const reducer = (currentState, newState)=>{
    return {
        ...currentState,
        ...newState
    };
};
function useHotspotForm(param) {
    let { region , portalId , formId , target , autohide  } = param;
    const initialState = {
        loading: true,
        show: false
    };
    const [{ loading , show  }, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, initialState);
    const toggleShow = ()=>setState({
            show: !show
        });
    const noShow = ()=>{
        setState({
            show: false
        });
        initHotspotForm();
    };
    const initHotspotForm = ()=>{
        hbspt.forms.create({
            region,
            portalId,
            formId,
            target,
            onFormReady: ()=>{
                setState({
                    loading: false
                });
            },
            onBeforeFormInit: (ctx)=>{
                if (ctx.pageUrl) {
                    setState({
                        loading: false
                    });
                }
            },
            onFormSubmitted: function() {
                setState({
                    show: true
                });
                if (autohide) {
                    const timerHubspot = setTimeout(()=>{
                        noShow();
                    }, 5000);
                    return ()=>{
                        clearTimeout(timerHubspot);
                    };
                }
            }
        });
    };
    return {
        loading,
        show,
        toggleShow,
        noShow,
        initHotspotForm
    };
}


/***/ }),

/***/ 7763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Careers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./src/@shared/service/cms-api.ts + 1 modules
var cms_api = __webpack_require__(7746);
;// CONCATENATED MODULE: ./src/assets/img/carrers-hero.webp
/* harmony default export */ var carrers_hero = ({"src":"/_next/static/media/carrers-hero.ed181a5c.webp","height":1067,"width":1600,"blurDataURL":"data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAADwAQCdASoIAAUAAkA4JZQCdAEWUNQXvsAA/Z1+3avqLO7TPvYIS3kbJph5Txr6q5Cb7bpKIYQklhhHnNZLMkAA","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./src/assets/img/about-casper.webp
var about_casper = __webpack_require__(6162);
;// CONCATENATED MODULE: ./src/assets/img/niamh-profile.webp
/* harmony default export */ var niamh_profile = ({"src":"/_next/static/media/niamh-profile.417ec604.webp","height":196,"width":196,"blurDataURL":"data:image/webp;base64,UklGRsIAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDkAAAABYFtbe5Ksguv6TpUuk+BVOgEeNkRETIDwKq0rT3gjwOR3GDAMll97Xp/rVBgwqHLnuthykcgTGQsAVlA4IGIAAADQAQCdASoIAAgAAkA4JbACdAD0tpeNGAD+uB/c1d9R/nuRS48ZX+piZC0r8Gftf89qz6BbOZ1r6l117f2E/Lv8RH/EB76luePx/C7c1f/syd/jgJF3POzt+Czv1GNSQYAAAA==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/img/karan-profile.webp
/* harmony default export */ var karan_profile = ({"src":"/_next/static/media/karan-profile.fa2b3931.webp","height":196,"width":196,"blurDataURL":"data:image/webp;base64,UklGRrwAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDUAAAABYBXJbhuRceP/61Q8EQDJ5dJARMQESN5a27JkBdC8Y2Bsjd/W52f2EwPjKBcTtEhYeqtRAABWUDggYAAAANABAJ0BKggACAACQDgliAJ0APl2NKIgAP64WPvyc/789K+mJFbH9f++S75HmgbdyOirLOiIwsNZTLxsT6D166SLx5DMeyibx/8y/KTGR2ltNATMrIMS//MHanWG+74AAA==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/img/iulia-profile.webp
/* harmony default export */ var iulia_profile = ({"src":"/_next/static/media/iulia-profile.9f97cf70.webp","height":196,"width":196,"blurDataURL":"data:image/webp;base64,UklGRrwAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDQAAAABYBRJkqLxsgdz/p+0oGdXANeRiIiYAFFXq1PRBJDUkiFjK7+1jp9iyZDZtwiDuIqxtQUVVlA4IGIAAAAwAgCdASoIAAgAAkA4JbACdDXAAUNr5K2GAAD+aMEfk60oFcwWLHxcWtrUltcKohIbZr1iXUGgyAX8WjdqsyrZrpBsebLW3sQXUrcO/z03It8Xp7OQPkDhz9Nuz8/+BLAAAA==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/img/joe-profile.webp
/* harmony default export */ var joe_profile = ({"src":"/_next/static/media/joe-profile.4cd937cf.webp","height":196,"width":196,"blurDataURL":"data:image/webp;base64,UklGRrgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDkAAAABYBvJdhOVggfRf8CQyTSDjWU5XBERMQFCqhiVFPLkujilwoNHxYtvTD9X0njw2HHlgmUQxZzdVAsAVlA4IFgAAACwAQCdASoIAAgAAkA4JZQCdADzes2gAP75uweHTX0ZEb2UXUTP6uNfVlMI/1W9oQm/tCGXUhpfX7/oHppz+4b+obV9qjdR2iKR5/sabGLtsnkfP5fyAAAA","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./src/@shared/components/head/customHead/customHead.tsx
var customHead = __webpack_require__(3065);
// EXTERNAL MODULE: ./src/@shared/components/hero/Hero/Hero.tsx
var Hero = __webpack_require__(4516);
// EXTERNAL MODULE: ./src/@shared/components/content/ContentCenter/ContentCenter.tsx
var ContentCenter = __webpack_require__(6751);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx + 1 modules
var Newsletter2 = __webpack_require__(7654);
// EXTERNAL MODULE: ./src/@shared/components/cards/CardHorizontal4/CardHorizontal4.tsx + 1 modules
var CardHorizontal4 = __webpack_require__(8838);
// EXTERNAL MODULE: ./src/@shared/components/accordion/Accordion/Accordion.tsx
var Accordion = __webpack_require__(7333);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(5005);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 7 modules
var esm_Accordion = __webpack_require__(5607);
// EXTERNAL MODULE: ./src/@shared/functions/animations.ts
var animations = __webpack_require__(6091);
// EXTERNAL MODULE: ./src/@shared/components/accordion/JobAccordion/JobAccordion.module.scss
var JobAccordion_module = __webpack_require__(986);
var JobAccordion_module_default = /*#__PURE__*/__webpack_require__.n(JobAccordion_module);
;// CONCATENATED MODULE: ./src/@shared/components/accordion/JobAccordion/JobAccordion.tsx








function JobAccordion(param) {
    let { customClass , items  } = param;
    const componentClass = "JobAccordion ".concat((JobAccordion_module_default()).JobAccordion, " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const itemClass = "".concat((JobAccordion_module_default()).itemContainer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnSelect = (eventKey)=>{
        if (eventKey) {
            setTimeout(()=>{
                console.log(eventKey);
                (0,animations/* scrollToTargetAdjusted */.rP)(eventKey, 200);
            }, 250);
        }
        console.log("eventKey", eventKey, "event", event);
    };
    var _body;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Accordion/* default */.Z, {
                onSelect: handleOnSelect,
                children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Accordion/* default.Item */.Z.Item, {
                            className: "mb-3",
                            eventKey: item._id,
                            id: item._id,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Accordion/* default.Header */.Z.Header, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: itemClass,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "h5 mb-0",
                                                children: item.title
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-0",
                                                children: item.location
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Accordion/* default.Body */.Z.Body, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jobBody",
                                            dangerouslySetInnerHTML: {
                                                __html: (_body = item.body) !== null && _body !== void 0 ? _body : ""
                                            }
                                        }),
                                        item.externalLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.externalLink,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "outline",
                                                className: "btnBlogVertical",
                                                children: "Apply Now"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                })
                            ]
                        }, item._id)
                    }, item._id))
            })
        })
    });
}

// EXTERNAL MODULE: ./src/modules/careers/components/OpenRoles/OpenRoles.module.scss
var OpenRoles_module = __webpack_require__(2043);
var OpenRoles_module_default = /*#__PURE__*/__webpack_require__.n(OpenRoles_module);
;// CONCATENATED MODULE: ./src/modules/careers/components/OpenRoles/OpenRoles.tsx






function OpenRoles(param) {
    let { jobs  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (OpenRoles_module_default()).openRolesContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                y: 100,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                md: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "half-title",
                                        children: "Careers"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: "h1",
                                        children: [
                                            "Open ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-green",
                                                children: "roles"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                md: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: (OpenRoles_module_default()).hrStyle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-5",
                                        children: "We are always looking for outstanding talent. Not seeing the right fit for you here? Feel free to submit an open application and check back frequently for new postings!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        target: "_blank",
                                        href: "https://apply.workable.com/casperlabs/j/E9C5207739/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "secondary",
                                            children: "Submit application"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAccordion, {
                items: jobs
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/assets/icons/check.svg
/* harmony default export */ var check = ({"src":"/_next/static/media/check.88fae931.svg","height":17,"width":26});
// EXTERNAL MODULE: ./src/@shared/components/icon/index.tsx + 3 modules
var icon = __webpack_require__(8068);
// EXTERNAL MODULE: ./src/modules/careers/components/RecruitmentProcess/RecruitmentProcess.module.scss
var RecruitmentProcess_module = __webpack_require__(2421);
var RecruitmentProcess_module_default = /*#__PURE__*/__webpack_require__.n(RecruitmentProcess_module);
;// CONCATENATED MODULE: ./src/modules/careers/components/RecruitmentProcess/RecruitmentProcess.tsx





function RecruitmentProcess() {
    const numberClass = "mb-0 me-3 fw-bold ".concat((RecruitmentProcess_module_default()).number);
    const lineClass = "".concat((RecruitmentProcess_module_default()).line);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (RecruitmentProcess_module_default()).recruitmentProcessContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "mb-7",
                        children: [
                            "Our five stage ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-green",
                                children: "recruitment"
                            }),
                            " process"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RecruitmentProcess_module_default()).overflow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (RecruitmentProcess_module_default()).timelineContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "position-relative d-flex align-items-center mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: numberClass,
                                                children: "1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: lineClass
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "title fw-bold mb-4",
                                        children: "Review"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (RecruitmentProcess_module_default()).desc,
                                        children: "We start by reviewing application materials in search of the best talent."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "position-relative d-flex align-items-center mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: numberClass,
                                                children: "2"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: lineClass
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "title fw-bold mb-4",
                                        children: "Video/Intro call"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (RecruitmentProcess_module_default()).desc,
                                        children: "In this call, we tell you all about the company and get to know you."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "position-relative d-flex align-items-center mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: numberClass,
                                                children: "3"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: lineClass
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "title fw-bold mb-4",
                                        children: "Interview"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (RecruitmentProcess_module_default()).desc,
                                        children: "Once we determine you’re a fit, you’ll have a 1-on-1 interview with your prospective department and may also be asked to present your skills in a sample task."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "position-relative d-flex align-items-center mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: numberClass,
                                                children: "4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: lineClass
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "title fw-bold mb-4",
                                        children: "Offer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (RecruitmentProcess_module_default()).desc,
                                        children: "After interviews are complete, we’ll send you a competitive offer."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "position-relative d-flex align-items-center mb-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: numberClass,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                source: check.src
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "title fw-bold mb-4",
                                        children: "Welcome!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (RecruitmentProcess_module_default()).desc,
                                        children: "Next up is getting you ready for the employee onboarding process and answering any further questions you may have."
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/modules/careers/components/OurMission/OurMission.module.scss
var OurMission_module = __webpack_require__(5887);
var OurMission_module_default = /*#__PURE__*/__webpack_require__.n(OurMission_module);
;// CONCATENATED MODULE: ./src/modules/careers/components/OurMission/OurMission.tsx




function OurMission() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "p-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb-5 h1",
                    children: "Our Mission"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "mb-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 7,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Lead the era of distributed computing by giving every organization access to state-of-the-art technologies and services."
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (OurMission_module_default()).gridContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex w-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "h1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-red",
                                            children: " 20"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "languages spoken"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OurMission_module_default()).vl
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex w-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "h1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-purple",
                                            children: " 18"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "different countries where our team members are located"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OurMission_module_default()).vl
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex w-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "h1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-green",
                                            children: " 93"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "93 percent annual team member retention"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Image.js
var Image = __webpack_require__(1330);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(6529);
// EXTERNAL MODULE: ./src/assets/icons/carousel-arrow-left.svg
var carousel_arrow_left = __webpack_require__(2745);
// EXTERNAL MODULE: ./src/assets/icons/carousel-arrow-right.svg
var carousel_arrow_right = __webpack_require__(7935);
// EXTERNAL MODULE: ./src/@shared/components/quote/QuoteFull3/QuoteFull3.module.scss
var QuoteFull3_module = __webpack_require__(3043);
var QuoteFull3_module_default = /*#__PURE__*/__webpack_require__.n(QuoteFull3_module);
;// CONCATENATED MODULE: ./src/@shared/components/quote/QuoteFull3/QuoteFull3.tsx



function QuoteFull3(param) {
    let { quote , author , customClass , authorImage  } = param;
    const componentClass = "QuoteFull3 ".concat((QuoteFull3_module_default()).QuoteFull3, " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: componentClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            className: "align-items-center gx-lg-6 gy-lg-0 gy-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (QuoteFull3_module_default()).authorImg,
                        style: {
                            backgroundImage: 'url("'.concat(authorImage, '")')
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    md: 9,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "quote",
                            children: quote
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "author fw-bold mb-0",
                            children: author
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/modules/careers/components/PeopleStories/PeopleStories.module.scss
var PeopleStories_module = __webpack_require__(455);
var PeopleStories_module_default = /*#__PURE__*/__webpack_require__.n(PeopleStories_module);
;// CONCATENATED MODULE: ./src/modules/careers/components/PeopleStories/PeopleStories.tsx








const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: {
            max: 4000,
            min: 1200
        },
        items: 2
    },
    desktop: {
        breakpoint: {
            max: 1199.99,
            min: 992
        },
        items: 2
    },
    tablet: {
        breakpoint: {
            max: 991.99,
            min: 768
        },
        items: 1
    },
    mobile: {
        breakpoint: {
            max: 767.99,
            min: 0
        },
        items: 1
    }
};
const ButtonGroup = (param)=>{
    let { next , previous , length , ...rest } = param;
    const { carouselState: { currentSlide , deviceType  }  } = rest;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PeopleStories_module_default()).carouselButtonGroup,
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: carousel_arrow_left/* default.src */.Z.src,
                alt: "left arrow",
                className: (currentSlide === 0 ? (PeopleStories_module_default()).carouselDisabled : (PeopleStories_module_default()).carouselArrow, "arrow-left"),
                onClick: ()=>previous && previous()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: carousel_arrow_right/* default.src */.Z.src,
                alt: "right arrow",
                className: (currentSlide + responsive[deviceType].items === length ? (PeopleStories_module_default()).carouselDisabled : (PeopleStories_module_default()).carouselArrow, "arrow-right"),
                onClick: ()=>next && next()
            })
        ]
    });
};
function PeopleStories(param) {
    let { list  } = param;
    const key = (0,react.useId)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "peopleStories position-relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
            responsive: responsive,
            arrows: false,
            infinite: true,
            renderButtonGroupOutside: true,
            customButtonGroup: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
                length: list.length
            }),
            children: list && list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "m-5 m-md-5 m-lg-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteFull3, {
                        authorImage: item.authorImg,
                        author: item.author,
                        quote: item.quote
                    })
                }, key + index))
        })
    });
}

;// CONCATENATED MODULE: ./src/modules/careers/components/CareerPage/CareerPage.tsx



















function CareersPage(param) {
    let { jobs , title , description , og  } = param;
    const heroTitle = "Help us write blockchain’s next chapter.";
    const JoinCasperLabsTitle = 'Why join <span class="text-red">Casper Labs?</span>';
    const CardHorizontal4Items = [
        {
            title: "Competitive Salary",
            desc: "We offer a competitive salary combined with employment in a stable, long-term-oriented, and well-founded company.",
            bgColor: "#BCFC07"
        },
        {
            title: "Ownership Incentives",
            desc: "Casper Labs offers long-term incentive plans in the form of both the Casper token and share options.",
            bgColor: "#AD53E5"
        },
        {
            title: "Fully Remote",
            desc: "Casper Labs offers a fully remote working environment that allows team members to work when, where, and how they want. ",
            bgColor: "#4589F6"
        },
        {
            title: "Customized IT Equipment",
            desc: "We provide a generous budget for IT equipment of your choice.",
            bgColor: "#F622E6"
        },
        {
            title: "Flexible Time Off",
            desc: "We understand that things happen, from sickness to just needing an extra day off to recuperate or deal with family issues.",
            bgColor: "#3EDC64"
        },
        {
            title: "Education Budget",
            desc: "We provide an education budget and dedicated time off to pursue the education you prefer - whatever allows you to grow is fine with us.",
            bgColor: "#F9AACA"
        }
    ];
    const AccordionItems = [
        {
            title: "Ownership",
            desc: "By taking ownership, we stay proactive, find the best solutions to complex problems, and don’t shy away from responsibility. It lets us stay open-minded with a big-picture perspective that contributes to the overall success of the company. We augment this by offering ownership incentive plans."
        },
        {
            title: "Autonomy and Flexibility",
            desc: "Late night sessions or early mornings, the Nevada desert or Finnish forest, we want you to work where you feel inspired. Everyone has their own way of achieving excellence, and we don’t let location get in our way."
        },
        {
            title: "Solutions Oriented",
            desc: "We see every problem as a latent opportunity - a solution waiting to happen. That’s why our work environment is founded on pragmatism and teamwork rather than status or competition between colleagues."
        },
        {
            title: "Partnership and Mutual Respect",
            desc: "Casper Labs thrives on healthy and respectful relationships. We always assume that our peers have good intentions and are receptive to others. We are direct, but always respectful."
        },
        {
            title: "International Working Environment",
            desc: "It’s no secret that diversity of thought leads to more innovative solutions. Our international environment helps to introduce new perspectives and fosters cooperation and respect among the ever-growing talent pool created by our increasingly connected world."
        },
        {
            title: "Personal Growth",
            desc: "Blockchain is growing, and we’re growing along with it. We recognize that personal growth is one of the strongest sources of motivation. That’s why, along with working with like-minded and high-level professionals, we invest in coaching and support personal development activities."
        }
    ];
    const Quotes = [
        {
            author: "Niamh",
            quote: "It’s exciting to work with a blockchain that can be upgraded as business needs change - this has really resonated with businesses.",
            authorImg: niamh_profile.src
        },
        {
            author: "Karan",
            quote: "The culture here makes everyone feel connected - nobody is just an ID number.",
            authorImg: karan_profile.src
        },
        {
            author: "Iulia",
            quote: "I’ve worked with a lot of different teams and engineers and I recognized Casper Labs strong team.",
            authorImg: iulia_profile.src
        },
        {
            author: "Joe",
            quote: "I’m here because I can develop my professional skills in a positive atmosphere while working on interesting projects.",
            authorImg: joe_profile.src
        }
    ];
    const aboutCasperTitle = 'About <span class="text-red">Casper Labs</span>';
    const pageClass = "careersPage overflow-hidden ";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: pageClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customHead/* default */.Z, {
                title: title,
                description: description,
                og: og,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: carrers_hero.src,
                    as: "image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                animation: "fadeIn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                            isHeader: true,
                            customClass: "heroServices pt-0 pb-0",
                            col1: 6,
                            col2: 6,
                            halfTitle: "careers",
                            title: heroTitle,
                            desc: "Casper is building the team that helps businesses work more thoughtfully, efficiently, and impactfully.",
                            linkButton: {
                                label: "see open positions",
                                link: "#jobs",
                                variant: "secondary"
                            },
                            bgImage: carrers_hero.src
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCenter/* default */.Z, {
                                colWidth: 10,
                                title: JoinCasperLabsTitle,
                                desc: "With vast growth opportunities, projects with global impact, high-level industry professionals, and game-changing technologies, Casper Labs is an ideal destination to take the next step in your career. Join our team of builders and innovators to drive the next wave of blockchain technology!",
                                ContentCenterChild: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleStories, {
                                        list: Quotes
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurMission, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ourCulture",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                        customClass: "pb-6",
                                        sectionTitle: "Our Culture",
                                        items: AccordionItems
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                            y: 400,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHorizontal4/* default */.Z, {
                                hasArrow: true,
                                customClass: "benefitsSection",
                                sectionTitle: "The Benefits We Offer",
                                items: CardHorizontal4Items
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "jobs",
                            children: jobs && /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenRoles, {
                                jobs: jobs
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitmentProcess, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                customClass: "AboutCasperLabs p-0",
                                colLg1: 6,
                                colLg2: 6,
                                title: aboutCasperTitle,
                                desc: "A growing number of organizations, from fast-growth companies to the public sector and Fortune 500 are choosing to build on Casper, thanks to its completely secure and future-proof architecture.",
                                linkButton: {
                                    label: "About us",
                                    link: "/company",
                                    variant: "secondary"
                                },
                                bgImage: about_casper/* default.src */.Z.src
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter2/* default */.Z, {
                            col1: 5,
                            col2: 7,
                            title: "Sign up for our newsletter!"
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/assets/img/default-splash-card.png
var default_splash_card = __webpack_require__(699);
;// CONCATENATED MODULE: ./src/pages/careers/index.tsx








var __N_SSP = true;
function Careers() {
    const { data  } = (0,es.useQuery)([
        "careers"
    ], ()=>(0,cms_api/* getCareers */.Rf)());
    const jobs = data.data;
    const title = "Careers, Culture & Job Opportunities | Casper Labs";
    const description = "Join the dynamic team at Casper Labs and help us write blockchain's next chapter. Explore our job opportunities and apply today.";
    const og = {
        ogTitle: title,
        ogDescription: description,
        ogImage: default_splash_card/* default.src */.Z.src
    };
    const defaultActiveKey = jobs && jobs.length > 0 ? jobs[0]._id : "";
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            (0,animations/* scrollObjFromAnchor */.EA)(router.asPath, 90);
            if (router.query.section) {
                (0,animations/* scrollToTargetAdjusted */.rP)(router.query.section.toString(), 90);
            }
        }, 1500);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CareersPage, {
        jobs: jobs,
        defaultActiveKey: defaultActiveKey,
        title: title,
        description: description,
        og: og
    });
}


/***/ }),

/***/ 986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"JobAccordion_itemContainer__K83Ft"};

/***/ }),

/***/ 8546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"CardHorizontal4_card__GgvZS","cardBody":"CardHorizontal4_cardBody__LjhE_"};

/***/ }),

/***/ 5380:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContent":"Hero_childrenContent__hSc1T"};

/***/ }),

/***/ 5973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"ListLoader_loaderContainer__hS6rF"};

/***/ }),

/***/ 3043:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"QuoteFull3":"QuoteFull3_QuoteFull3__5q4wK","authorImg":"QuoteFull3_authorImg__RJA8l"};

/***/ }),

/***/ 2043:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"openRolesContainer":"OpenRoles_openRolesContainer__w4IvU","hrStyle":"OpenRoles_hrStyle__fJ9W2"};

/***/ }),

/***/ 5887:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"OurMission_gridContainer__giOqJ","vl":"OurMission_vl__2uckS"};

/***/ }),

/***/ 455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselDisabled":"PeopleStories_carouselDisabled__ORk7G","carouselArrow":"PeopleStories_carouselArrow__Z6wGr","carouselButtonGroup":"PeopleStories_carouselButtonGroup__4CaAU"};

/***/ }),

/***/ 2421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"recruitmentProcessContainer":"RecruitmentProcess_recruitmentProcessContainer__PDTET","overflow":"RecruitmentProcess_overflow__5z4ej","timelineContainer":"RecruitmentProcess_timelineContainer__h1irE","line":"RecruitmentProcess_line__D3Q2q","number":"RecruitmentProcess_number__C8F_9","desc":"RecruitmentProcess_desc__fUBHr"};

/***/ }),

/***/ 8182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(6611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(9602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(9059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [437,529,445,774,888,179], function() { return __webpack_exec__(4931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);